import type { ReactNode } from 'react';

// PAY-29 — pastilles numérotées reliées par un trait, PREMIÈRE utilisation de
// ce patron dans ce projet. Vérifié AVANT tout code (Étape 0) : le seul
// stepper existant (`OnboardingWizard.tsx`, SCH-05/SCH-22) utilise un patron
// DIFFÉRENT — des onglets à pilule horizontaux (`bg-brand-600 px-3 py-1
// rounded-full`), jamais des cercles numérotés reliés par un trait — aucun
// composant réutilisable pour ce besoin précis. Créé ici comme fondation
// PARTAGÉE plutôt qu'un composant local à `Caisse.tsx`, même discipline déjà
// suivie pour `Modal`/`StatusTag`/`KpiCard`/`Avatar`/`EmptyState`.
export interface StepperStep {
  key: string;
  label: ReactNode;
}

export interface StepperProps {
  steps: StepperStep[];
  /** Index (0-based) de l'étape ACTIVE — les étapes d'index < currentIndex sont "complétées". */
  currentIndex: number;
}

export function Stepper({ steps, currentIndex }: StepperProps) {
  return (
    <ol className="ss-stepper flex items-start" data-testid="stepper">
      {steps.map((step, index) => {
        const isComplete = index < currentIndex;
        const isActive = index === currentIndex;
        return (
          <li
            key={step.key}
            className={`flex items-center ${index < steps.length - 1 ? 'flex-1' : ''}`}
            data-testid={`stepper-step-${step.key}`}
            data-state={isComplete ? 'complete' : isActive ? 'active' : 'upcoming'}
          >
            <div className="flex flex-col items-center gap-1">
              <span
                aria-current={isActive ? 'step' : undefined}
                className={[
                  'flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-sm font-semibold',
                  isComplete
                    ? 'bg-brand-600 text-white'
                    : isActive
                      ? 'border-2 border-brand-600 bg-white text-brand-700'
                      : 'border border-border-strong bg-surface-raised text-text-muted',
                ].join(' ')}
              >
                {isComplete ? '✓' : index + 1}
              </span>
              <span
                className={`text-xs font-medium whitespace-nowrap ${
                  isActive ? 'text-brand-700' : isComplete ? 'text-text-secondary' : 'text-text-muted'
                }`}
              >
                {step.label}
              </span>
            </div>
            {index < steps.length - 1 ? (
              <div
                aria-hidden="true"
                className={`mx-2 mt-4 h-0.5 flex-1 ${isComplete ? 'bg-brand-600' : 'bg-gray-200'}`}
              />
            ) : null}
          </li>
        );
      })}
    </ol>
  );
}
